<template>
  <div>
    <div @click="onPreviewClick" :class="`container${theModel.elementItem.ElementScale === 2 ? '4' :
        (theModel.elementItem.ElementScale === 1 ? '2' : '1')}chart`">
      <query-chart :class="`preview${theModel.elementItem.ElementScale === 2 ? '4' :
      (theModel.elementItem.ElementScale === 1 ? '2' : '1')}chart`"
        v-model="theModel.Element"
          :src-element="theModel.elementGraphItem"
          :inPreviewMode="true"
        />
    </div>
    <q-dialog maximized v-model="showFull" fit>
      <q-card>
        <q-card-section class="row items-center">
          <div class="text-h6">{{ theModel.Name }}</div>
          <q-space />
          <q-btn icon="close" flat round dense v-close-popup />
        </q-card-section>
        <q-separator />
        <q-card-section style="max-height: 90vh" class="scroll">
          <query-chart
            v-model="theModel.Element"
            :src-element="theModel.elementGraphItem"
            :inPreviewMode="true"
          />
        </q-card-section>
        <!-- <q-card-actions align="right">
          <q-btn flat :label="$t('close_label')" color="accent" v-close-popup />
        </q-card-actions> -->
      </q-card>
    </q-dialog>
  </div>
</template>
  
<script lang="ts">
  import { Component, Emit, Prop, Vue } from 'vue-facing-decorator';
  import QueryChart from './QueryChart.vue';
  import { QueryResultItem } from '../base-list/interfaces/ListTypes';
  
  @Component({
    name: 'QueryChartPreview',
    components: {
      QueryChart
    }
  })
  export default class QueryChartPreview extends Vue {
    @Prop({ default: undefined })
    modelValue?: QueryResultItem
    @Emit("update:modelValue") emitModelValue(arg: any ) { return arg; }
    showFull: boolean = false

    async onPreviewClick() {
      console.log('show preview')
      this.showFull = true;
    }

    get theModel() {
      return this.modelValue
    }

    set theModel(arg: any) {
      this.emitModelValue(arg)
    }
  }
</script>

<style lang="scss">

.container1chart {
  float: left;
  width: calc(100% - 20px);
  min-width: calc(100% - 20px);
  max-width: calc(100% - 20px);
  height: 40vh;
  margin: 10px;
  border-radius: 6px;
  position: relative;
  overflow: hidden;
  display: block;
  border: 1px solid lightgrey;
  cursor: pointer;

  & > * {
    pointer-events: none;
  }

  &::after {
    content: ''; /* Выводим пустой блок */
    position: absolute; /* Абсолютное позиционирование */
    left: 0px; right: 0px; /* Устанавливает ширину блока */
    bottom: 0; /* Положение от нижнего края */
    height: 1em; /* Высота */
    background: linear-gradient(to bottom, transparent, lightgrey 100%);
    pointer-events: none; /* Не реагирует на мышь */
  }
}

.container1chart:hover {
  &::after {
    content: ''; /* Выводим пустой блок */
    position: absolute; /* Абсолютное позиционирование */
    left: 0px; right: 0px; /* Устанавливает ширину блока */
    bottom: 0; /* Положение от нижнего края */
    height: 1em; /* Высота */
    background: linear-gradient(to bottom, transparent, lightblue 100%);
    pointer-events: none; /* Не реагирует на мышь */
  }
}

.container2chart {
  float: left;
  width: calc(50% - 20px);
  min-width: calc(50% - 20px);
  max-width: calc(50% - 20px);
  height: 40vh;
  margin: 10px;
  border-radius: 6px;
  position: relative;
  overflow: hidden;
  display: block;
  border: 1px solid lightgrey;
  cursor: pointer;

  & > * {
    pointer-events: none;
  }

  &::after {
    content: ''; /* Выводим пустой блок */
    position: absolute; /* Абсолютное позиционирование */
    left: 0px; right: 0px; /* Устанавливает ширину блока */
    bottom: 0; /* Положение от нижнего края */
    height: 1em; /* Высота */
    background: linear-gradient(to bottom, transparent, lightgrey 100%);
    pointer-events: none; /* Не реагирует на мышь */
  }
}

.container2chart:hover {
  &::after {
    content: ''; /* Выводим пустой блок */
    position: absolute; /* Абсолютное позиционирование */
    left: 0px; right: 0px; /* Устанавливает ширину блока */
    bottom: 0; /* Положение от нижнего края */
    height: 1em; /* Высота */
    background: linear-gradient(to bottom, transparent, lightblue 100%);
    pointer-events: none; /* Не реагирует на мышь */
  }
}

.container4chart {
  float: left;
  width: calc(25% - 20px);
  min-width: calc(25% - 20px);
  max-width: calc(25% - 20px);
  height: 40vh;
  margin: 10px;
  border-radius: 6px;
  position: relative;
  overflow: hidden;
  display: block;
  border: 1px solid lightgrey;
  cursor: pointer;

  & > * {
    pointer-events: none;
  }

  &::after {
    content: ''; /* Выводим пустой блок */
    position: absolute; /* Абсолютное позиционирование */
    left: 0px; right: 0px; /* Устанавливает ширину блока */
    bottom: 0; /* Положение от нижнего края */
    height: 1em; /* Высота */
    background: linear-gradient(to bottom, transparent, lightgrey 100%);
    pointer-events: none; /* Не реагирует на мышь */
  }
}

.container4chart:hover {
  &::after {
    content: ''; /* Выводим пустой блок */
    position: absolute; /* Абсолютное позиционирование */
    left: 0px; right: 0px; /* Устанавливает ширину блока */
    bottom: 0; /* Положение от нижнего края */
    height: 1em; /* Высота */
    background: linear-gradient(to bottom, transparent, lightblue 100%);
    pointer-events: none; /* Не реагирует на мышь */
  }
}

.preview1chart {
  transform-origin: center;
  transform: translate(0, -10%) scale(0.8);
}

.preview2chart {
  transform-origin: center;
  transform: translate(0, -10%) scale(0.8);
}

.preview4chart {
  transform-origin: center;
  transform: translate(0, -30%) scale(0.8, 0.4);
}

</style>